'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'sun';
var width = 576;
var height = 512;
var aliases = [9728];
var unicode = 'f185';
var svgPathData = ['M0 256c0 8.4 4.4 16.3 11.7 20.6L104.3 332.1 78 436.8c-2 8.2 .3 16.9 6.3 22.8S99 468 107.2 466l104.7-26.3 55.5 92.7c4.3 7.2 12.2 11.7 20.6 11.7s16.3-4.4 20.6-11.7l55.5-92.7 104.7 26.3c8.2 2 16.9-.4 22.8-6.3S500 445 498 436.8l-26.3-104.7 92.7-55.5c7.2-4.3 11.7-12.2 11.7-20.6s-4.4-16.3-11.7-20.6L471.7 179.9 498 75.1c2-8.2-.4-16.8-6.3-22.8S477 44 468.9 46L364.1 72.3 308.6-20.4c-4.3-7.2-12.2-11.7-20.6-11.7-7.4 0-14.3 3.4-18.8 9.1l-1.8 2.6-55.5 92.6-104.7-26.2c-8.2-2-16.8 .4-22.8 6.3S76 67 78 75.1l26.2 104.7-92.6 55.5C4.4 239.7 0 247.6 0 256zm400 0a112 112 0 1 1 -224 0 112 112 0 1 1 224 0z', 'M176 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSun = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;